import { Directive } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { BaseDirectiveObject } from '../base-directive-object';
/**
 * Clase base de los componentes de la aplicacion que proporciona metodos de utilidad
 * para la gestion de suscripciones
 */
@Directive()
export abstract class BaseComponent extends BaseDirectiveObject implements OnDestroy {


}